<template>
<div class="to-self">
  <el-row>
    <el-col
      :lg="12"
      :sm="12"
      :xs="24"
    >
      <el-form
        class="elform"
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item
          :label="$t('Accounts_receivable')"
          prop="toAccount"
        >
          <el-input
            :placeholder="$t('please_input')"
            v-model="form.toAccount"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Payees_email')"
        >
          <el-input
            :placeholder="$t('please_input')"
            v-model="form.toEmail"
          >
          </el-input>
          <p class="email-desc">{{$t('User.transDesc')}}</p>
        </el-form-item>
        <el-form-item
        >
          <div class="nav-title">{{$t('Amount_that_can_be_withdrawn')}}<el-tooltip class="item" popper-class="maxwidthtooltips" effect="dark" :content="withdrawtips" placement="top">
            <i class="el-icon-info icon-el iconcolor"></i>
      </el-tooltip></div>
          <p class="balance">${{amountConversion(fromAccountInfo)}}</p>
        </el-form-item>
        <el-form-item
          :label="$t('User.transAmount')"
          prop="amount"
          class="has-prefix-item"
        >
          <el-input
            :placeholder="$t('please_input')"
            :value="form.amount"
            @input="inputHandle"
          >
            <span slot="prefix">$</span>
          </el-input>
        </el-form-item>
        <!-- PC端: 验证方式 + 验证码分开展示 -->
        <template v-if="!realMobile">
          <el-form-item
            :label="$t('Verification_mode')"
            prop="veriType"
            class="has-prefix-item"
          >
            <el-select
              style="width: 100%"
              v-model="form.veriType"
            >
              <el-option
                v-for="(item,index) in availableVeriTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <p>{{phoneOrEmail}}</p>
          </el-form-item>
          <el-form-item
            :label="$t('Verification_Code')"
            prop="veriCode"
          >
            <div class="code-box pr">
              <el-input
                :placeholder="$t('please_input')"
                v-model="form.veriCode"
                class="w-full"
              ></el-input>
              <span class="code-btn-text active pa theme-color pointer" v-if="isCode && !codeLoading"
                    @click="getCode">{{$t('Send_verification_code')}}</span>
              <span class="code-btn-text active pa theme-color" v-else-if="codeLoading">
                <i class="el-icon-loading"></i>
              </span>
              <span class="code-btn-text pa theme-color" v-else>{{isCodeNumber}}s {{$t('Register.againVer')}}</span>
            </div>
          </el-form-item>
        </template>
        <!-- 移动端: 验证方式独立select + 验证码输入框与发送按钮并排 -->
        <template v-else>
          <el-form-item
            :label="$t('Verification_mode')"
            prop="veriType"
          >
            <el-select
              style="width: 100%"
              v-model="form.veriType"
            >
              <el-option
                v-for="(item,index) in availableVeriTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Verification_Code')"
            prop="veriCode"
          >
            <div class="code-inline-mobile">
              <el-input
                :placeholder="$t('Partner.inputVer')"
                v-model="form.veriCode"
                class="code-inline-input"
              ></el-input>
              <el-button
                class="code-inline-btn"
                type="primary"
                :loading="codeLoading"
                :disabled="!isCode || codeLoading"
                @click="getCode"
              >
                <span v-if="isCode">{{$t('Send_verification_code')}}</span>
                <span v-else>{{isCodeNumber}}s</span>
              </el-button>
            </div>
          </el-form-item>
        </template>
        <el-form-item>
          <el-button
            class="sure-btn"
            type="primary"
            :loading="submitLoading"
            @click="payHandle"
          >{{$t('Confirm_transfer_out')}}</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { getTransferPhoneVer,mt4Transfer } from '@/api/userCenter.js';
import { mapGetters } from 'vuex'
import {amountInputValidate, onlyTwoBitFloat, validatEmail} from "@/utils/validate";
import {getDictValueApi} from "@/api/user";
export default {
  name: "toOther",
  props: {
    currentAccount: {
      type: Number,
    },
    accountList:{
      type: Array,
      default(){
        return [];
      }
    }
  },
  data() {
    let _this = this;
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('please_input_your_email')));
      } else {
        if (!validatEmail(value)) {
          callback(new Error(_this.$t('Register.errorMail')));
        } else {
          callback();
        }
      }
    };
    var validateMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('payChannel.inputMoney')));
      }else {
        if(!onlyTwoBitFloat(value)){
          callback(new Error(this.$t('User.onlyInputTwoBitNumber')));
          this.$emit('request-err');
          return;
        }else {
          callback();
        }
      }
    };
    return {
      // 表单
      veriTypeList:[
        { label: _this.$t('mobile_phone'), value: 1 },
        { label: _this.$t('email'), value: 2 },
      ],
      form: {
        toAccount: '',
        toEmail: '',
        amount: '',
        veriType: 2,
        veriCode: '',
      },
      rules: {
        toAccount: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
        ],
        toEmail: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' },
        ],
        amount: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' },
        ],
        veriCode: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
        ],
      },
      // 发送验证码
      isCode: true,
      isCodeNumber: 60,
      codeLoading: false,
      submitLoading: false,
      withdrawalratio: '',
    }
  },
  created(){

     this.getDictValue();
  },
  computed: {
    ...mapGetters(['userInfo', 'realMobile', 'smsVerificationEnabled']),
    availableVeriTypeList(){
      return this.smsVerificationEnabled
        ? this.veriTypeList
        : this.veriTypeList.filter((option) => option.value !== 1);
    },
    verificationType(){
      return this.smsVerificationEnabled ? this.form.veriType : 2;
    },
    phoneOrEmail(){
      if(this.verificationType == 1){
        return this.userInfo.phone;
      }else {
        return this.userInfo.email;
      }
    },
    fromAccountInfo(){
      if(!this.accountList.length){
        return {
          availableBalance: '',
        }
      }else {
        let currentMtInfo = this.accountList.filter((item) => {
          return item.login == this.currentAccount;
        });
        return currentMtInfo[0];
      }
    },
    withdrawtips(){
      return this.$t('User.withdrawtipsName') + this.withdrawalratio + this.$t('User.withdrawtipsAction');
    }
  },
  methods: {
    convertToPercentageIntl(numStr, decimals = 0) {
      const num = parseFloat(numStr);
      if (isNaN(num)) {
        throw new Error('无效的输入');
      }
      return new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    },
    getDictValue(){
      getDictValueApi({
        type: 'WITHDRAW_RATIO',
      }).then((res) => {
        if(res.data&&res.data.content[0]){
          this.withdrawalratio = this.convertToPercentageIntl(res.data.content[0].value);
        }
      })
    },
    inputHandle(val){
      this.form.amount = amountInputValidate(val);
    },
    payHandle(item){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.applyRequest();
        }else {
          console.log('no-pass');
        }
      })
    },
    amountConversion(data){
      let newdata = data.availableBalance;
      if(data.currency == 'USC'&&data.availableBalance){
        newdata = newdata/100;
      }
      return newdata||0;
    },
    applyRequest(){
      let parmas = {
        oprCustId : this.userInfo.id,
        transferType : 2,
        oprLogin : this.fromAccountInfo.login,
        targetLogin : this.form.toAccount,
        amount : this.form.amount,
        targetEmail : this.form.toEmail,
        phoneVerCode : this.form.veriCode,
        type: this.verificationType,
      }
      this.submitLoading = true;
      mt4Transfer(parmas).then((res) => {

        this.$emit('reduce-balance',this.form.amount);
        this.submitLoading = false;

        this.$message({
          type: 'success',
          message: this.$t('Submitted_please_wait_for_review')
        });

      }).catch((res) => {
        this.submitLoading = false;
      })
    },
    getCode() {
      if (this.codeLoading || !this.isCode) return;
      let parmas = {
        custId: this.userInfo.id,
        type: this.verificationType,
      }
      this.codeLoading = true;
      getTransferPhoneVer(parmas).then((res) => {
        if(res){
          this.isCode = false;
          this.timerOut();

          this.$message({
            message: this.$t('User.verCodeSendSuccess'),
            type: 'success'
          });
        }
      }).finally(() => {
        this.codeLoading = false;
      })
    },
    timerOut() {
      let _this = this;
      let timer1 = setTimeout(() => {
        clearTimeout(timer1);
        if (_this.isCodeNumber > 0) {
          _this.isCodeNumber = --_this.isCodeNumber;
          _this.timerOut();
        } else {
          clearTimeout(timer1);
          this.isCode = true;
          this.isCodeNumber = 60;
        }
      }, 1000);
    },
  },
}
</script>

<style lang="scss" scoped>
.to-self {
  padding-top: 20px;
  .nav-title {
    font-size: 16px;
    font-weight: 600;
    color: #5E5873;
  }
  .email-desc {
    line-height: 1.5;
    margin-top: 10px;
    color: #B9B9C3;
  }
  .balance {
    font-size: 16px;
    font-weight: 600;
    color: #D85E5F;
    line-height: 1.2;
  }
  .code-btn-text {
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .code-inline-mobile {
    position: relative;
    display: inline-block;
    width: 100%;
    .code-inline-input {
      width: 60%;
      margin-right: 4%;
    }
    .code-inline-btn {
      width: 36%;
    }
  }
  .has-prefix-item {
    /deep/ .el-input__prefix {
      left: 15px;
    }
  }
  .sure-btn {
    margin-top: 30px;
  }
}
</style>
